import React from 'react';
import RevenueTrendSelector from './component/RevenueTrendSelector';
import RevenueTrend from './component/RevenueTrend';
// import { trendDataMock } from './component/RevenueTrend/mockData';
import classnames from 'classnames';
import './index.scss';
import RevenueProgress from './component/RevenueProgress';

interface RevenueTrendPanelProps {
  className?: string;
  style?: React.CSSProperties;
  segmentList: any;
  selectorList: any;
  trendConfig: any;
  trendCommonConfig: any;
  changeData: (data: any) => void;
  data: any;
  dataKey: string;
  tabFilter: any;
  changeDataItem: any;
  textInfo: any;
}

const RevenueTrendPanel = (props: RevenueTrendPanelProps) => {
  const { className, style, selectorList, segmentList, trendConfig, trendCommonConfig, changeData, data, dataKey, tabFilter, textInfo, ...restProps } = props;
  const revenueTrendData = data?.[dataKey] || {};
  const filterDate = props?.tabFilter?.date;
  const { selectedGame, selectedSegment } = props?.changeDataItem || {};
  return (
    <div className={classnames('dbh-revenue-trend-container', className)} style={style}>
      <RevenueTrendSelector
        selectorList={selectorList}
        segmentList={segmentList}
        changeData={changeData}
        data={data}
        content={<RevenueProgress
          data={{ ...revenueTrendData ?? {}, ...data ?? {} }}
          changeData={changeData}
          tabFilter={tabFilter}
          {...(data || {})}
          {...(restProps || {})}
        />}
      />
      <RevenueTrend
        trendConfig={trendConfig}
        trendCommonConfig={trendCommonConfig}
        data={data}
        filterDate={filterDate}
        infoTextObj={textInfo?.[`${selectedGame.value}_${selectedSegment.value}`]}
      />
    </div>
  );
};

export default RevenueTrendPanel;
